import React from "react";
import deploymentsData from "./deploymentsData.jsx";
import linkIcon from "../../../assets/images/techIcons/link.png";
import classes from "./deployments.module.css";

const RecentDeployments = () => {
  const handleDeploymentClick = (link) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={classes.deploymentsSection}>
      <p className={classes.deploymentsHeading}>DEPLOYMENTS..</p>
      <div className={classes.deploymentsContainerOutside}>
        {deploymentsData.map((deployment) => (
          <div
            key={deployment.id}
            className={classes.deploymentContainer}
            onClick={() => handleDeploymentClick(deployment.link)}
          >
            <div className={classes.deploymentIconContainer}>
              <img src={deployment.icon} alt={deployment.title} />
            </div>
            <div className={classes.deploymentContent}>
              <div className={classes.deploymentTitle}>{deployment.title}</div>
              <div className={classes.deploymentDescription}>
                {deployment.description}
              </div>
            </div>
            <div className={classes.deploymentLinkContainer}>
              <img src={linkIcon} alt="link" className={classes.linkIcon} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentDeployments;
